var DB_NAME = "shyj",
    VERSION = 1,
    db;

function initDB (tableNames, key = "id", dbName = DB_NAME) {
    var request = indexedDB.open(dbName, VERSION);
    request.onerror = function (e) {
        console.log(e.currentTarget.error.message);
    };
    request.onsuccess = function (event) {
        db = event.target.result;
    };
    // console.log(event.target === request); // true
    request.onupgradeneeded = function (event) {
        // 更新对象存储空间和索引 ....
        var database = event.target.result;
        tableNames.forEach(tableName => {
            database.createObjectStore(tableName, {
                keyPath: key
            });
        });
    };
}
async function addDBData (data, tableName = "base", dbName = DB_NAME) {
    return new Promise(resolve => {
        var request = indexedDB.open(dbName, VERSION);
        request.onsuccess = function (event) {
            db = event.target.result;
            var transaction = db.transaction([tableName], "readwrite");
            var objectStore = transaction.objectStore(tableName); // 指定对象存储空间
            var request = objectStore.add(data);
            resolve(request);
        };
    });
}
async function updateDBData (data, tableName = "base", dbName = DB_NAME) {
    return new Promise(resolve => {
        var request = indexedDB.open(dbName, VERSION);
        request.onsuccess = function (event) {
            db = event.target.result;
            var transaction = db.transaction([tableName], "readwrite");
            var objectStore = transaction.objectStore(tableName); // 指定对象存储空间
            var request = objectStore.put(data);
            resolve(request);
        };
    });
}

async function removeDBData (data, tableName = "base", dbName = DB_NAME) {
    return new Promise(resolve => {
        var request = indexedDB.open(dbName, VERSION);
        request.onsuccess = function (event) {
            db = event.target.result;
            var transaction = db.transaction([tableName], "readwrite");
            var objectStore = transaction.objectStore(tableName); // 指定对象存储空间
            var request = objectStore.delete(data);
            resolve(request);
        };
    });
}

async function getDBDataByKey (key, tableName = "base", dbName = DB_NAME) {
    return new Promise(resolve => {
        var requestDB = indexedDB.open(dbName, VERSION);
        requestDB.onsuccess = function (event) {
            db = event.target.result;
            var transaction = db.transaction([tableName], "readonly");
            var objectStore = transaction.objectStore(tableName); // 指定对象存储空间
            var request = objectStore.get(key);
            request.onsuccess = function (event) {
                let data = event.target.result;
                // console.log("查询成功！", data);
                resolve(data);
            };
        };
    });
}
async function getDBData (tableName, dbName = DB_NAME) {
    return new Promise(resolve => {
        var requestDB = indexedDB.open(dbName, VERSION);
        requestDB.onsuccess = function (event) {
            db = event.target.result;
            var transaction = db.transaction([tableName], "readonly");
            var objectStore = transaction.objectStore(tableName); // 指定对象存储空间
            var request = objectStore.getAll();
            request.onsuccess = function (event) {
                let data = event.target.result;
                resolve(data);
            };
        };
    });
}

async function removeDBDataAll (tableName, dbName = DB_NAME) {
    return new Promise(resolve => {
        var requestDB = indexedDB.open(dbName, VERSION);
        requestDB.onsuccess = function (event) {
            db = event.target.result;
            var transaction = db.transaction([tableName], "readwrite");
            var objectStore = transaction.objectStore(tableName); // 指定对象存储空间
            var request = objectStore.clear();
            request.onsuccess = function (event) {
                let data = event.target.result;
                resolve(data);
            };
        };
    });
}

export {
    initDB,
    addDBData,
    getDBDataByKey,
    getDBData,
    removeDBDataAll,
    updateDBData,
    removeDBData
};
